<!-- 电费充值-->
<template>
  <el-dialog class="electricity-recharge-dialog"
             v-loading="loadData.loading"
             :title="`充值电费-宿舍：${title.dormitoryName || null}第${title.floorNum || 0}层${title.roomName}【${title.dormitoryRoomType ? title.dormitoryRoomType.roomTypeName : '暂无房间'}】`"
             :visible.sync="show" :close-on-click-modal="false" width="750px" @close="close">
    <el-steps direction="vertical" :active="curSteps">
      <el-step title="第1步：完善信息并核对无误后，点击“生成支付二维码”按钮以创建微信支付所需的二维码。">
        <template #description>
          <el-card shadow="never" class="mb-1">
            <el-form ref="form" label-width="110px" :rules="rules" :model="formData">
              <el-form-item label="充值人" prop="userId">
                <el-radio-group v-if="!!dormUserList.length" v-model="formData.userId" @change="handleDormUser">
                  <el-radio v-for="item in dormUserList" :key="item.userId" :label="item.userId">
                    {{ item.stuName || item.realName }}
                  </el-radio>
                </el-radio-group>
                <div class="flex">
                  <tool-tips-group tips-content="名字搜索最少输入2个汉字。<br/>
                         身份证/录取编号搜索最少输入6位数字。<br/>"
                                   style="">
                    <!--   <br/>只能搜索所管辖学院的学生。  <span>搜索学生：</span>-->
                    <el-checkbox style="margin-right: 10px;" v-model="forOther"
                                 @change="handleForOther">非本宿舍成员
                    </el-checkbox>

                    <el-autocomplete
                      v-if="forOther"
                      class="input-width-radio"
                      v-model="userInfo.value"
                      :fetch-suggestions="querySearchAsync"
                      :placeholder="formData.userType===2?'学生名、身份证号、录取编号':'教师姓名、身份证、工号'"
                      size="small"
                      clearable
                      @select="handleSelect" style="width:388px;transform: translateY(5px);">
                      <template #prepend>
                        <el-radio-group v-model="formData.userType" size="small" @change="handleUserType">
                          <el-radio-button
                            v-for="{paramValue,paramName} in userTypeList"
                            :key="paramValue"
                            :label="+paramValue">{{ paramName }}
                          </el-radio-button>
                        </el-radio-group>
                      </template>
                    </el-autocomplete>
                  </tool-tips-group>
                </div>
              </el-form-item>
              <el-form-item label="充值电表度数" prop="rechargeNumber">
                <el-input-number :min="10" :max="10000" :precision="0"
                                 size="small"
                                 :step="10"
                                 controls-position="right"
                                 v-model="formData.rechargeNumber" />
                <el-checkbox class="ml-1" v-model="isWechatPay">是否微信支付</el-checkbox>
              </el-form-item>
            </el-form>
            <!--            -->
            <div class="font-center">
              <el-button :disabled="loadData.loading" size="small" type="success" @click="renderQRCode">生成支付二维码
              </el-button>
            </div>
          </el-card>
        </template>
      </el-step>
      <el-step title="第2步：使用微信扫一扫功能，扫描二维码以完成支付操作。">
        <template #description>
          <div style="border-radius: 4px;border: 1px solid #EBEEF5; padding: 0 10px;">
            <div class="success-tip"
                 v-show="qrCodeInfo.userId"
            >
              支持微信支付。<br />
              支付完成后，可通过“水电表“按钮打开 ”充值/赠送/清零记录“模块，查看充值记录。
            </div>
            <div class="font-center" style="min-height: 240px;">
              <canvas
                v-show="qrCodeInfo.userId"
                ref="canvas"
                width="200px"
                height="200px"
              ></canvas>
              <p v-if="qrCodeInfo.userId">充值度数：<span class="font-danger"
                                                         style="font-family:impact, sans-serif ;font-size: 36px;">{{ qrCodeInfo.rechargeNumber
                }}</span>
                度{{ qrCodeInfo.isWechatPay ? '(微信支付)' : '' }}</p>
            </div>
          </div>
        </template>
      </el-step>
    </el-steps>
    <!--    <el-divider>微信支付二维码</el-divider>-->

    <template #footer>
      <el-button :disabled="loadData.loading" @click="close">关 闭</el-button>
      <!--      save('进行电费充值',electricityRechargeApi,`${title.dormitoryName || null}第${title.floorNum || 0}层${title.roomName}电费充值成功！`)-->
    </template>
  </el-dialog>
</template>

<script>
import dialog from '@/vue/mixins/dialog'
import userAutocomplete from '@/vue/mixins/user-autocomplete'
import { getRechargeQRCodeApi, getWXRechargeQRCodeApi } from '@/api/dorm/free-electric-api'
import QRCode from 'qrcode'

export default {
  name: 'electricityRechargeDialog',
  mixins: [dialog, userAutocomplete],
  props: {},
  data() {
    return {
      curSteps: 1,
      isWechatPay: true, // 是否为微信支付
      userType: 2,
      forOther: false, // 是否为其他宿舍充值
      userInfo: { value: '', data: {} },
      formData: {
        userType: 2, // 此字段只有前端使用
        dormitoryRoomId: '',
        userId: '',
        rechargeNumber: 100
      },
      qrCodeInfo: {}, // 防止生成二维码后依旧修改数据，在这里备份一个formData
      dormUserList: [], // 宿舍成员
      rules: {
        userId: { required: true, message: '请选择充值人', trigger: 'blur' },
        rechargeNumber: [{ required: true, message: '请输入充值金额', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value) {
                if (+value % 10) {
                  return callback(new Error('充值度数必须为10的倍数'))
                } else {
                  return callback()
                }
              } else {
                return callback()
              }
            },
            trigger: 'blur'
          }]
      }
    }
  },
  computed: {},
  async mounted() {
    await this.$nextTick()
    this.preTitle = `为${this.title.dormitoryName || null}第${this.title.floorNum || 0}层${this.title.roomName}`
    if (!this.id) {
      this.close()
    }
    this.formData.dormitoryRoomId = this.id
    await this.getDormStudentList()
  },
  methods: {
    // 根据宿舍id获取已绑定宿舍学生/教职工列表
    async getDormStudentList() {
      try {
        this.loadData.loading = true
        const res = await this.$http.getDormRoomBedListQuery({
          pageNum: 1,
          pageSize: 50,
          dormitoryRoomId: this.id
        })
        this.dormUserList = res.data.filter(item => item.userId)
        if (!this.dormUserList?.length) {
          this.forOther = true
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loadData.loading = false
      }
    },
    async handleRecharge() {
    },
    handleUserType() {
      this.userInfo = { value: '', data: {} }
      this.formData.userId = ''
    },
    // 非本宿舍成员充值
    handleForOther(val) {
      if (val) {
        this.formData.userId = ''
      }
    },
    // 选择充值人后 清空 远程搜索
    handleDormUser(val) {
      if (val && this.forOther) {
        this.userInfo = { value: '', data: {} }
        this.forOther = false
      }
    },
    renderQRCode() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.loadData.loading = true
            const api = this.isWechatPay ? getWXRechargeQRCodeApi : getRechargeQRCodeApi
            const res = await api(this.formData)
            this.qrCodeInfo = JSON.parse(JSON.stringify({ ...this.formData, isWechatPay: this.isWechatPay }))
            this.curSteps = 2
            QRCode.toCanvas(
              this.$refs.canvas,
              res.data,
              {
                errorCorrectionLevel: 'H',
                width: 200 // 设置二维码的宽度
              },
              (error) => {
                if (error) console.error(error)
              }
            )
          } catch (e) {
            console.error(e)
          } finally {
            this.loadData.loading = false
          }
        } else {
          return false
        }
      })
    },
    // 获取选中的教职工/学生信息
    handleSelect(person) {
      this.userInfo.data = person
      this.formData.userId = person.userId || person.id
    }
  }
}
</script>
<style lang="scss">
.electricity-recharge-dialog {
  .el-step__description {
    padding-right: 0;
    color: #404040;
  }

  .el-card__body {
    padding-left: 5px;
    padding-right: 5px;
  }
}
</style>
